import "./InlineServiceCard.scss";

import React from "react";

import classnames from "classnames";
import ReactPlaceholder from "react-placeholder";

import {
    SpsCard,
} from "@spscommerce/ds-react";

import config from "../../App.config";
import { InlineServicePlaceHolder } from "../Placeholders";

function InlineServiceCardBody(props) {
    const { servicesLoaded, onToggle } = props;
    return (
        <div>
            <ReactPlaceholder
                customPlaceholder={<InlineServicePlaceHolder onToggle={onToggle} />}
                ready={servicesLoaded}
            >
                {null}
            </ReactPlaceholder>
        </div>
    );
}

function InlineServiceCard(props) {
    const {
        environment,
        hasHeader,
        headerTitle,
        className,
        services,
        ...rest
    } = props;

    // Any service whose slug is included  in the blacklist array for any environment
    // won't display in that environment
    const filteredServices = services.filter(
        (service) =>
            !config.documentation.serviceDocsBlacklist[environment].includes(service.id) &&
            service.public &&
            service.active &&
            service.serviceType === "API",
    );

    const cardClass = classnames("sps-card--collpased", className);
    return (
        <div className="inline-service-card">
            {hasHeader ? (
                <SpsCard headerTitle={headerTitle} className={cardClass}>
                    <InlineServiceCardBody
                        services={filteredServices}
                        {...rest}
                    />
                </SpsCard>
            ) : (
                <SpsCard className={cardClass}>
                    <InlineServiceCardBody
                        services={filteredServices}
                        {...rest}
                    />
                </SpsCard>
            )}
        </div>
    );
}

export default InlineServiceCard;
export { InlineServiceCardBody };
